"use strict";

var _regeneratorRuntime = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var c8ql_query_1 = require("./c8ql-query");

var collection_1 = require("./collection");

var connection_1 = require("./connection");

var cursor_1 = require("./cursor");

var error_1 = require("./error");

var graph_1 = require("./graph");

var tenant_1 = require("./tenant");

var stream_1 = require("./stream");

var route_1 = require("./route");

var btoa_1 = require("./util/btoa");

var event_1 = require("./event");

var user_1 = require("./user");

var streamapps_1 = require("./streamapps");

function colToString(collection) {
  if (collection_1.isC8Collection(collection)) {
    return String(collection.name);
  } else return String(collection);
}

var FABRIC_NOT_FOUND = 1228;

var Fabric = /*#__PURE__*/function () {
  function Fabric(config) {
    _classCallCheck(this, Fabric);

    this._connection = new connection_1.Connection(config);
  }

  _createClass(Fabric, [{
    key: "route",
    value: function route(path, headers) {
      return new route_1.Route(this._connection, path, headers);
    }
  }, {
    key: "close",
    value: function close() {
      this._connection.close();
    } // Fabric manipulation

  }, {
    key: "useFabric",
    value: function useFabric(fabricName) {
      this._connection.setFabricName(fabricName);

      return this;
    }
  }, {
    key: "useBearerAuth",
    value: function useBearerAuth(token) {
      this._connection.setHeader("authorization", "Bearer ".concat(token));

      return this;
    }
  }, {
    key: "useBasicAuth",
    value: function useBasicAuth(username, password) {
      this._connection.setHeader("authorization", "Basic ".concat(btoa_1.btoa("".concat(username, ":").concat(password))));

      return this;
    }
  }, {
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/database/current"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isC8Error(err) && err.errorNum === FABRIC_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "createFabric",
    value: function createFabric(fabricName, users, options) {
      return this._connection.request({
        method: "POST",
        path: "/database",
        body: {
          users: users || [],
          name: fabricName,
          options: options
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listFabrics",
    value: function listFabrics() {
      return this._connection.request({
        path: "/database"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "listUserFabrics",
    value: function listUserFabrics() {
      return this._connection.request({
        path: "/database/user"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "dropFabric",
    value: function dropFabric(fabricName) {
      return this._connection.request({
        method: "DELETE",
        path: "/database/".concat(fabricName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "login",
    value: function login(email, password) {
      var _this = this;

      return this._connection.request({
        method: "POST",
        path: "/_open/auth",
        body: {
          email: email,
          password: password
        },
        absolutePath: true
      }, function (res) {
        _this.useBearerAuth(res.body.jwt);

        _this.useTenant(res.body.tenant);

        return res.body;
      });
    }
  }, {
    key: "updateFabricSpotRegion",
    value: function updateFabricSpotRegion(tenantName, fabricName) {
      var datacenter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      return this._connection.request({
        method: "PUT",
        path: "_tenant/".concat(tenantName, "/_fabric/").concat(fabricName, "/database/").concat(datacenter),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return this._connection.request({
        method: "GET",
        path: "/events"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteEvents",
    value: function deleteEvents(eventIds) {
      return this._connection.request({
        method: "DELETE",
        path: "/events",
        body: JSON.stringify(eventIds)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "event",
    value: function event(entityName, eventId) {
      return new event_1.Event(this._connection, entityName, eventId);
    } // Collection manipulation

  }, {
    key: "collection",
    value: function collection(collectionName) {
      return new collection_1.DocumentCollection(this._connection, collectionName);
    }
  }, {
    key: "edgeCollection",
    value: function edgeCollection(collectionName) {
      return new collection_1.EdgeCollection(this._connection, collectionName);
    }
  }, {
    key: "listCollections",
    value: function listCollections() {
      var _this2 = this;

      var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this._connection.request({
        path: "/collection",
        qs: {
          excludeSystem: excludeSystem
        }
      }, function (res) {
        return _this2._connection.c8Major <= 2 ? res.body.collections : res.body.result;
      });
    }
  }, {
    key: "collections",
    value: function collections() {
      var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var collections;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.listCollections(excludeSystem);

              case 2:
                collections = _context.sent;
                return _context.abrupt("return", collections.map(function (data) {
                  return collection_1.constructCollection(_this3._connection, data);
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "truncate",
    value: function truncate() {
      var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        var collections;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.listCollections(excludeSystem);

              case 2:
                collections = _context2.sent;
                _context2.next = 5;
                return Promise.all(collections.map(function (data) {
                  return _this4._connection.request({
                    method: "PUT",
                    path: "/collection/".concat(data.name, "/truncate")
                  }, function (res) {
                    return res.body;
                  });
                }));

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    } // Graph manipulation

  }, {
    key: "graph",
    value: function graph(graphName) {
      return new graph_1.Graph(this._connection, graphName);
    }
  }, {
    key: "listGraphs",
    value: function listGraphs() {
      return this._connection.request({
        path: "/_api/graph"
      }, function (res) {
        return res.body.graphs;
      });
    }
  }, {
    key: "graphs",
    value: function graphs() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;

        var graphs;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.listGraphs();

              case 2:
                graphs = _context3.sent;
                return _context3.abrupt("return", graphs.map(function (data) {
                  return _this5.graph(data._key);
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "transaction",
    value: function transaction(collections, action, params, options) {
      if (typeof params === "number") {
        options = params;
        params = undefined;
      }

      if (typeof options === "number") {
        options = {
          lockTimeout: options
        };
      }

      if (typeof collections === "string") {
        collections = {
          write: [collections]
        };
      } else if (Array.isArray(collections)) {
        collections = {
          write: collections.map(colToString)
        };
      } else if (collection_1.isC8Collection(collections)) {
        collections = {
          write: colToString(collections)
        };
      } else if (collections && typeof collections === "object") {
        collections = Object.assign({}, collections);

        if (collections.read) {
          if (!Array.isArray(collections.read)) {
            collections.read = colToString(collections.read);
          } else collections.read = collections.read.map(colToString);
        }

        if (collections.write) {
          if (!Array.isArray(collections.write)) {
            collections.write = colToString(collections.write);
          } else collections.write = collections.write.map(colToString);
        }
      }

      return this._connection.request({
        method: "POST",
        path: "/transaction",
        body: Object.assign({
          collections: collections,
          action: action,
          params: params
        }, options)
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "query",
    value: function query(_query, bindVars, opts) {
      var _this6 = this;

      if (c8ql_query_1.isC8QLQuery(_query)) {
        opts = bindVars;
        bindVars = _query.bindVars;
        _query = _query.query;
      } else if (c8ql_query_1.isC8QLLiteral(_query)) {
        _query = _query.toC8QL();
      }

      return this._connection.request({
        method: "POST",
        path: "/cursor",
        body: Object.assign({}, opts, {
          query: _query,
          bindVars: bindVars
        })
      }, function (res) {
        return new cursor_1.ArrayCursor(_this6._connection, res.body, res.host);
      });
    }
  }, {
    key: "validateQuery",
    value: function validateQuery(query) {
      return this._connection.request({
        method: "POST",
        path: "/query",
        body: {
          query: query
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "explainQuery",
    value: function explainQuery(explainQueryObj) {
      return this._connection.request({
        method: "POST",
        path: "/_api/explain",
        body: Object.assign({}, explainQueryObj)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getCurrentQueries",
    value: function getCurrentQueries() {
      return this._connection.request({
        path: "/query/current"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearSlowQueries",
    value: function clearSlowQueries() {
      return this._connection.request({
        method: "DELETE",
        path: "/query/slow"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getSlowQueries",
    value: function getSlowQueries() {
      return this._connection.request({
        path: "/query/slow"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "terminateRunningQuery",
    value: function terminateRunningQuery(queryId) {
      return this._connection.request({
        method: "DELETE",
        path: "/query/".concat(queryId)
      }, function (res) {
        return res.body;
      });
    } // Function management

  }, {
    key: "listFunctions",
    value: function listFunctions() {
      return this._connection.request({
        path: "/c8qlfunction"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createFunction",
    value: function createFunction(name, code, isDeterministic) {
      return this._connection.request({
        method: "POST",
        path: "/c8qlfunction",
        body: {
          name: name,
          code: code,
          isDeterministic: isDeterministic
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "dropFunction",
    value: function dropFunction(name, group) {
      var path = typeof group === "boolean" ? "/c8qlfunction/".concat(name, "?group=").concat(group) : "/c8qlfunction/".concat(name);
      return this._connection.request({
        method: "DELETE",
        path: path
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "version",
    value: function version() {
      var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "GET",
        path: "/_fabric/".concat(this._connection.getFabricName(), "/_api/version"),
        absolutePath: true,
        qs: {
          details: details
        }
      }, function (res) {
        return res.body;
      });
    } // Tenant

  }, {
    key: "useTenant",
    value: function useTenant(tenantName) {
      this._connection.setTenantName(tenantName);

      return this;
    }
  }, {
    key: "tenant",
    value: function tenant(email, tenantName) {
      return new tenant_1.Tenant(this._connection, email, tenantName);
    }
  }, {
    key: "listTenants",
    value: function listTenants() {
      return this._connection.request({
        method: "GET",
        path: "/tenants",
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    } //Stream

  }, {
    key: "stream",
    value: function stream(streamName, local) {
      var isCollectionStream = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return new stream_1.Stream(this._connection, streamName, local, isCollectionStream);
    }
    /* -------------------------------- DUPLICATE ------------------------------- */
    // TODO: @RACHIT choose which Fn to deprecate

  }, {
    key: "getStreams",
    value: function getStreams() {
      var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return this._connection.request({
        method: "GET",
        path: "/streams",
        qs: global === undefined ? "" : "global=".concat(global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getAllStreams",
    value: function getAllStreams() {
      return this._connection.request({
        method: "GET",
        path: "/streams"
      }, function (res) {
        return res.body;
      });
    }
    /* ----------------------------------- --- ---------------------------------- */
    // TODO: RACHIT/VIKAS DO WE STILL HAVE THIS API?

  }, {
    key: "listPersistentStreams",
    value: function listPersistentStreams() {
      var local = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "GET",
        path: "/streams/persistent",
        qs: "local=".concat(local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearBacklog",
    value: function clearBacklog() {
      return this._connection.request({
        method: "POST",
        path: "/streams/clearbacklog"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearSubscriptionBacklog",
    value: function clearSubscriptionBacklog(subscription) {
      return this._connection.request({
        method: "POST",
        path: "/streams/clearbacklog/".concat(subscription)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(subscription) {
      return this._connection.request({
        method: "POST",
        path: "/streams/unsubscribe/".concat(subscription)
      }, function (res) {
        return res.body;
      });
    } //edge locations

  }, {
    key: "getAllEdgeLocations",
    value: function getAllEdgeLocations() {
      return this._connection.request({
        method: "GET",
        path: "/datacenter/all",
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getTenantEdgeLocations",
    value: function getTenantEdgeLocations() {
      return this._connection.request({
        method: "GET",
        path: "/datacenter/_tenant/".concat(this._connection.getTenantName()),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getLocalEdgeLocation",
    value: function getLocalEdgeLocation() {
      return this._connection.request({
        method: "GET",
        path: "/datacenter/local",
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "changeEdgeLocationSpotStatus",
    value: function changeEdgeLocationSpotStatus(dcName, isSpot) {
      return this._connection.request({
        method: "PUT",
        path: "_api/datacenter/".concat(dcName, "/").concat(isSpot),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    } //user

  }, {
    key: "user",
    value: function user(_user) {
      var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return new user_1.default(this._connection, _user, email);
    }
  }, {
    key: "getAllUsers",
    value: function getAllUsers() {
      return this._connection.request({
        method: "GET",
        path: "/_admin/user"
      }, function (res) {
        return res.body;
      });
    } //User Queries / RESTQL

  }, {
    key: "listSavedQueries",
    value: function listSavedQueries() {
      return this._connection.request({
        method: "GET",
        path: "/restql/user"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "saveQuery",
    value: function saveQuery(name) {
      var parameter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var value = arguments.length > 2 ? arguments[2] : undefined;

      try {
        if (name.includes(" ")) throw "Spaces are not allowed in query name";
        return this._connection.request({
          method: "POST",
          path: "/restql",
          body: {
            query: {
              name: name,
              parameter: parameter,
              value: value
            }
          }
        }, function (res) {
          return res.body;
        });
      } catch (err) {
        return err;
      }
    }
  }, {
    key: "executeSavedQuery",
    value: function executeSavedQuery(queryName) {
      var bindVars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._connection.request({
        method: "POST",
        path: "/restql/execute/".concat(queryName),
        body: {
          bindVars: bindVars
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "updateSavedQuery",
    value: function updateSavedQuery(queryName) {
      var parameter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var value = arguments.length > 2 ? arguments[2] : undefined;
      return this._connection.request({
        method: "PUT",
        path: "/restql/".concat(queryName),
        body: {
          query: {
            parameter: parameter,
            value: value
          }
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteSavedQuery",
    value: function deleteSavedQuery(queryName) {
      return this._connection.request({
        method: "DELETE",
        path: "/restql/".concat(queryName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createRestqlCursor",
    value: function createRestqlCursor(query) {
      var bindVars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._connection.request({
        method: "POST",
        path: "/restql/dynamic",
        body: {
          bindVars: [bindVars],
          cache: true,
          count: true,
          options: {
            profile: true
          },
          query: query
        }
      }, function (res) {
        return res.body;
      });
    } // Stream Applications

  }, {
    key: "streamApp",
    value: function streamApp(appName) {
      return new streamapps_1.Streamapps(this._connection, appName);
    }
  }, {
    key: "createStreamApp",
    value: function createStreamApp(regions, appDefinition) {
      return this._connection.request({
        method: "POST",
        path: "/_api/streamapps",
        body: JSON.stringify({
          definition: appDefinition,
          regions: regions
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getAllStreamApps",
    value: function getAllStreamApps() {
      return this._connection.request({
        method: "GET",
        path: "/_api/streamapps"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "validateStreamappDefinition",
    value: function validateStreamappDefinition(appDefinition) {
      return this._connection.request({
        method: "POST",
        path: "/_api/streamapps/validate",
        body: {
          definition: appDefinition
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getSampleStreamApps",
    value: function getSampleStreamApps() {
      return this._connection.request({
        method: "GET",
        path: "/_api/streamapps/samples"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "name",
    get: function get() {
      return this._connection.getFabricName() || null;
    }
  }]);

  return Fabric;
}();

exports.Fabric = Fabric;